import CheckIcon from '@mui/icons-material/Check';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import useWindowSize from '@repo/ui/src/components/shared/window-size';

export const ChildrenProducts = (props) => {
  const { childrenProducts } = props;
  return (
    <>
      {childrenProducts?.map((item) => {
        const linkObj = item.deliveryKey ? buildLinkObj({ link: item.deliveryKey }) : { href: '' };
        const childThumbUrl = item.getMainImageSize(300, 1, 1);
        return (
          <div key={item.deliveryKey} className="row">
            <a
              href={linkObj.href}
              className="tw-underline tw-cursor-pointer"
              target="_blank"
              rel="noreferrer"
            >
              <div className="col-12">
                <LazyLoadImage
                  imgComponent={
                    <img
                      className="tw-inline-block tw-my-4 tw-text-center"
                      src={childThumbUrl}
                      alt={item.title}
                    />
                  }
                />
              </div>
            </a>
          </div>
        );
      })}
    </>
  );
};

const ProductBundleInfo = ({ activeParent, childrenProducts }) => {
  const currentBundleLinkObj = activeParent?.deliveryKey
    ? buildLinkObj({ link: activeParent.deliveryKey })
    : { href: '' };
  const currentImg = activeParent.getMainImageSize(500, 1, 1);
  const [width] = useWindowSize();
  const isLg = width > 992;
  return (
    <div className="tw-flex tw-max-w-[1200px] tw-m-auto tw-py-20 tw-px-5 md:tw-px-0">
      <div className="tw-grid md:tw-grid-cols-2">
        <div>
          <h5 className="tw-text-center lg:tw-text-start tw-pl-auto lg:tw-pl-3">Includes</h5>
          <ul className="tw-list-none">
            {activeParent && (
              <a
                href={currentBundleLinkObj.href}
                className="tw-underline tw-cursor-pointer"
                target="_blank"
                rel="noreferrer"
              >
                <li className="py-2" key={`included_in_bundle_${activeParent.sku}`}>
                  <div className="tw-flex tw-align-center tw-py-2">
                    <CheckIcon className="tw-mr-2" />
                    <div>{`${activeParent.title}`}</div>
                  </div>
                </li>
              </a>
            )}
            {childrenProducts?.map((product) => {
              if (!product.isOrderable === false) {
                return null;
              }
              return (
                <a
                  key={product.sku}
                  href={product.productUrl}
                  className="tw-underline tw-cursor-pointer"
                  target="_blank"
                  rel="noreferrer"
                >
                  <li className="py-2" key={`included_in_bundle_${product.sku}`}>
                    <div className="tw-flex tw-align-center tw-py-2">
                      <CheckIcon className="tw-mr-2" />
                      <div className="tw-py-2">{`${product.title}`}</div>
                    </div>
                  </li>
                </a>
              );
            })}
          </ul>
        </div>
        <div className="tw-hidden md:tw-block">
          <div className="tw-grid tw-grid-cols-2">
            <a
              href={currentBundleLinkObj.href}
              className="tw-underline tw=cursor-pointer"
              target="_blank"
              rel="noreferrer"
            >
              <LazyLoadImage
                imgComponent={
                  <img className="tw-hidden md:tw-inline-block" src={currentImg} alt="" />
                }
              />
            </a>

            {isLg ? (
              <div className="tw-grid tw-grid-cols-3">
                <ChildrenProducts childrenProducts={childrenProducts} lgSize />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductBundleInfo;
